import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v2';

export const POPUP_IMAGE_PATH = 'popup_image_path';
export const NOTICE_FILE_PATH = 'notice_file_path';
export const NOTICE_IMAGE_PATH = 'notice_image_path';
export const NOTICE_CONTENT_PATH = 'notice_content_path';
export const ORIGIN_NOTICE_FILE_PATH = 'origin_notice_file_path';
export const ORIGIN_NOTICE_IMAGE_PATH = 'origin_notice_image_path';
export const ORIGIN_NOTICE_CONTENT_PATH = 'origin_notice_content_path';
export const ORIGIN_POPUP_IMAGE_PATH = 'origin_popup_image_path';
export const ORIGIN_POPUP_CONTENT_PATH = 'origin_popup_content_path';
export const ORIGIN_FIRMWARE_PATH = 'origin_firmware_path';

export const USER_STATE = {
    NORMAL: 1,
    SECESSION: 2,
};

export const DOC_KIND = {
    TERMS: 1,
    PRIVACY: 2,
}

// Utility functions
export const dateFormat = (data) => {
  if (data == null) return "";
  const year = data.substring(0, 4);
  const month = data.substring(5, 7);
  const day = data.substring(8, 10);
  return `${year}-${month}-${day}`;
};

/**
 * Display alert modal or browser alert as fallback.
 * @param {{title?: string, description: string, response_method?: string}} param0
 */
export function openAlert({ title = "알림", description = "", response_method }) {
  if (window.openAlert) {
    window.openAlert({ title, description, response_method });
  } else {
    alert(`${title}\n\n${description}`);
  }
}

/**
 * Display confirmation modal or browser confirm as fallback.
 * @param {{title?: string, description?: string, positive_method?: string, positive_param?: any, negative_method?: string, negative_param?: any, positive_btn?: string, negative_btn?: string}} options
 */
export function openConfirm({ title = '알림', description = '', positive_method, positive_param, negative_method, negative_param, positive_btn = '예', negative_btn = '아니요' }) {
  //console.log('utils/openConfirm', { title, description, positive_method, positive_param, negative_method, negative_param, positive_btn, negative_btn }, 'window.openConfirm?', !!window.openConfirm);
  if (window.openConfirm) {
    window.openConfirm({ title, description, positive_method, positive_param, negative_method, negative_param, positive_btn, negative_btn });
  } else {
    if (window.confirm(`${title}\n\n${description}`)) {
      if (positive_method) {
        const pm = positive_method;
        const pp = positive_param;
        if (typeof pm === 'function') {
          pm(pp);
        } else if (typeof window[pm] === 'function') {
          window[pm](pp);
        }
      }
    } else {
      if (negative_method) {
        const nm = negative_method;
        const np = negative_param;
        if (typeof nm === 'function') {
          nm(np);
        } else if (typeof window[nm] === 'function') {
          window[nm](np);
        }
      }
    }
  }
}

const s2ab = (s) => {
  let buf = new ArrayBuffer(s.length);
  let view = new Uint8Array(buf);
  for(let i = 0; i < s.length; i++){
      view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
}

export const exportExcel = (data, excelConfig = {excelFileName : "download.xlsx", sheetName : "Sheet1"}) => {
  let wb = XLSX.utils.book_new();
  let newWorksheet = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, newWorksheet, excelConfig.sheetName);
  let wbout = XLSX.write(wb, {bookType : 'xlsx', type : "binary"});
  saveAs(new Blob([s2ab(wbout)], {type : "application/octet-stream"}), excelConfig.excelFileName);
}

export const showPopup = (link, id) => { 
  const windowWidth = window.screen.width; //화면 사이즈 가로
  const windowHeight = window.screen.height; //화면 사이즈 세로
  const popupWidth= 1600; //팝업창 가로크기
  const popupHeight=900;  //팝업창 세로크기
  const popupX = (windowWidth / 2) - (popupWidth / 2);
  const popupY= (windowHeight / 2) - (popupHeight / 2);
  if(id === undefined){id = "a";}
  window.open(link, id, `'status=no, height=${popupHeight}, width=${popupWidth}, left=${popupX}, top=${popupY}`);
}
